import styled from 'styled-components'

export const Flyout = styled.div`
	background-color: ${(props) => props.theme.colors.backgroundPrimary};
	box-shadow: ${(props) => props.theme.shadows.default};
	opacity: ${(props) => (props.isOpen ? 1 : 0)};
	/* Set position to absolute or fixed based on the use case in the parent component */
	position: fixed;
	transition: 300ms opacity ease-in-out, 300ms visibility;
	visibility: ${(props) => (props.isOpen ? 'visible' : 'hidden')};
	z-index: ${(props) => props.theme.zIndexes.flyout};
`
